import { render, staticRenderFns } from "./NewBarcodeScanner.vue?vue&type=template&id=021fbb08&scoped=true&"
import script from "./NewBarcodeScanner.vue?vue&type=script&lang=js&"
export * from "./NewBarcodeScanner.vue?vue&type=script&lang=js&"
import style0 from "./NewBarcodeScanner.vue?vue&type=style&index=0&id=021fbb08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021fbb08",
  null
  
)

export default component.exports